import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock, FaBook } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MdSchool, MdPeople, MdPerson } from "react-icons/md";

import ListAcademicYear from "../ListAcademicYear/ListAcademicYear";
import CreateAcademicYear from "../CreateYear/Create";
const MainFileYear = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Academic Year Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}></div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Academic Year </span>
        </Box>
      </div>
      <Box p={5} flex="2" mb={9}>
        <CreateAcademicYear />

        <Tabs
          variant="soft-rounded"
          colorScheme="teal"
          isFitted
          p={2}
          // boxShadow="lg"
          borderRadius="md"
          bg={useColorModeValue("white", "gray.700")}
        >
          <TabList>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Academic Year's List
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={1}>
              <ListAcademicYear />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default MainFileYear;
